<div
  class="kgr-alert kgr-alert--warning kgr-hidden kgr-hidden--fadeInOnUnhidden kgr-hidden--"
  [class.is-unhidden]="showOfflineMessage"
  i18n
>
  Sie sind gerade offline. Einige Anwendungsbereiche benötigen eine Internetverbindung, um korrekt zu funktionieren.
</div>
<div class="kgr-alert kgr-alert--success kgr-hidden kgr-hidden--fadeInOnUnhidden" [class.is-unhidden]="showOnlineMessage">
  <div class="kgr-postfix kgr-postfix--gutters">
    <div class="kgr-postfix__fluid" i18n>
      Sie sind jetzt wieder online.
    </div>
    <div class="kgr-postfix__fixed">
      <button (click)="reload()" class="kgr-button kgr-button--icon">
        <svg kgrIcon="refresh"></svg>
      </button>
    </div>
  </div>
</div>
